import { RequestState } from "vuex-fetch-factory";
import { ManualModel } from "../models";

export interface StateInterface {
  vuexFetchersState: Map<string, Map<string, RequestState>>;
  manuals: ManualModel[];
}

const state: StateInterface = {
  vuexFetchersState: new Map(),
  manuals: []
};

export default state;
